import BaseException from '../common/BaseException';

class ResourceException extends BaseException {
    constructor(message, code) {
        super(message);
        this.code = code;
    }

    getResponseCode() {
        return this.code
    }
}

export default ResourceException;


// WEBPACK FOOTER //
// ./web/src/services/ResourceException.js